import { createBrowserHistory } from 'history';

export const HISTORY_BASENAME = '/';

export default createBrowserHistory({ basename: HISTORY_BASENAME });
